module.exports = __webpack_public_path__ + "static/media/One side Angle's Class III 14.9736c2b6.png";